/**
 * Notifications API client (uses existing axiosPrivate instance).
 * Backend base path: /notifications
 */

export async function fetchNotifications(axios, { company_id, limit = 30, skip = 0, unreadOnly = false, after, typeFilter }) {
  const body = { company_id, limit, skip, unreadOnly, typeFilter };
  if (after != null) body.after = after;
  const res = await axios.post("/notifications/list", body);
  return res.data;
}

export async function markNotificationRead(axios, { notification_id }) {
  const res = await axios.post("/notifications/mark-read", { notification_id });
  return res.data;
}

export async function markAllNotificationsRead(axios, { company_id, typeFilter }) {
  const res = await axios.post("/notifications/mark-all-read", { company_id, typeFilter });
  return res.data;
}

